import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import prdcts from "../products.json";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "../DataTableDemo.css";
import { AppContext } from "../../../utils/Context";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import html2canvas from "html2canvas";

import { ReactComponent as UpIcon } from "../../../images/upIcon.svg";
import { ReactComponent as DownIcon } from "../../../images/downIcon.svg";

const TableCombinedYoutube = (props) => {
  const [state, setState] = React.useContext(AppContext);
  const { t } = useTranslation();

  //-- moy_sectorielle
  function nombreTotalJoursEntreDeuxDates(dateDebut, dateFin) {
    const debut = new Date(dateDebut);
    const fin = new Date(dateFin);
    const differenceEnMillisecondes = fin - debut;
    const differenceEnJours =
      Math.floor(differenceEnMillisecondes / (1000 * 60 * 60 * 24)) + 1;
    return differenceEnJours;
  }

  props = props.state;
  const start_date = props.data.date_info.start_date;
  const end_date = props.data.date_info.end_date;
  const totalJours = nombreTotalJoursEntreDeuxDates(start_date, end_date);

  // Fonction pour formater un nombre avec millify et une précision de 3 chiffres après la virgule
  function millifyAvecPrecision(nombre) {
    if (typeof nombre !== "number" || isNaN(nombre)) {
      // Handle the case where nombre is not a valid number
      return 0; // or throw an error, log a message, etc.
    }

    const nombreFormate = nombre.toLocaleString();
    return nombre > 0 ? nombreFormate : 0;
  }

  function percentWithPrecision(nombre) {
    var arrondi =
      nombre.toString().substring(0, nombre.toString().indexOf(".") + 4) + "%";
    return arrondi;
  }

  function campareTwoValues(val1, val2) {
    if (val1 >= val2) {
      return <UpIcon className="fill-[#008000] w-5 table m-auto" />;
    } else {
      return <DownIcon className="fill-[#FF0000] w-5 table m-auto" />;
    }
  }

  const dataBench = props.data?.youtube?.dataBench?.total;

  const total_posts_moy = dataBench.length
    ? dataBench.reduce((sum, item) => sum + item.total_videos, 0) /
      dataBench.length
    : 0;

  const page_fans_moy = dataBench.length
    ? dataBench.reduce((sum, item) => sum + (item.total_abonnees ?? 0), 0) /
      dataBench.length
    : 0;
  const total_interactions_moy = dataBench.length
    ? dataBench.reduce((sum, item) => sum + item.total_interactions, 0) /
      dataBench.length
    : 0;

  const taux_interaction_moy = dataBench.length
    ? dataBench.reduce((sum, item) => {
        return sum + item.taux_interactions;
      }, 0) / dataBench.length
    : "0%";
  const nbr_posts_jour_moy = dataBench.length
    ? dataBench.reduce((sum, item) => {
        const nbr_post_day = totalJours ? item.total_videos / totalJours : 0;
        return sum + nbr_post_day;
      }, 0) / dataBench.length
    : 0;
  const post_video_moy = dataBench.length
    ? dataBench.reduce((sum, item) => {
        return sum + parseInt(item.posts_videos);
      }, 0) / dataBench.length
    : 0;
  const post_short_moy = dataBench.length
    ? dataBench.reduce((sum, item) => {
        return sum + parseInt(item.posts_short);
      }, 0) / dataBench.length
    : 0;
  const post_live_moy = dataBench.length
    ? dataBench.reduce((sum, item) => {
        return sum + item.posts_live;
      }, 0) / dataBench.length
    : 0;

  const moy_data_youtube = [];

  const table_moy_obj = {
    nbr_marque: dataBench.length,
    page_fans: millifyAvecPrecision(page_fans_moy),
    total_post: millifyAvecPrecision(total_posts_moy),
    total_interactions: millifyAvecPrecision(total_interactions_moy),
    taux_interaction: percentWithPrecision(taux_interaction_moy),
    nbr_posts_jour: millifyAvecPrecision(nbr_posts_jour_moy),
    posts_videos: millifyAvecPrecision(post_video_moy),
    posts_shorts: millifyAvecPrecision(post_short_moy),
    posts_live: millifyAvecPrecision(post_live_moy),
  };

  moy_data_youtube.push(table_moy_obj);

  //-- Chiffre clés
  const page_admin = state.currentPage.page_id;

  const filteredData = dataBench.filter((item) => item.page_id === page_admin);
  const AdminPageData = filteredData[0];

  //-- Taux d’engagement moyen des pages
  const total_fans_kf = AdminPageData?.total_abonnees;
  const total_interactions_kf = filteredData.reduce((sum, item) => {
    return sum + item.total_interactions;
  }, 0);
  const taux_interactions_kf = total_fans_kf
    ? percentWithPrecision((total_interactions_kf / total_fans_kf) * 100)
    : 0;

  //-- Nombre moyen des publications
  const total_posts_kf = parseInt(AdminPageData.total_videos);
  const nbr_moy_pub = total_posts_kf
    ? total_interactions_kf / total_posts_kf
    : 0;
  const nbr_moy_pub_sec = total_posts_moy
    ? total_interactions_moy / total_posts_moy
    : 0;

  //-- Nombre moyen des réactions par page
  const reaction_kf = parseInt(AdminPageData.interactions.reactions);
  const reaction_sec = dataBench.length
    ? dataBench.reduce(
        (acc, dataBench) => acc + parseInt(dataBench.interactions.reactions),
        0
      ) / dataBench.length
    : 0;

  //-- Nombre moyen des partages par page
  const views_kf = parseInt(AdminPageData.interactions.views);
  const views_sec = dataBench.length
    ? dataBench.reduce(
        (acc, element) => acc + parseInt(element.interactions.views),
        0
      ) / dataBench.length
    : 0;

  //-- Nombre moyen des commentaires par page
  const comments_kf = parseInt(AdminPageData.interactions.comments);
  const comments_sec = dataBench.length
    ? dataBench.reduce(
        (acc, dataBench) => acc + parseInt(dataBench.interactions.comments),
        0
      ) / dataBench.length
    : 0;

  const chiffre_key = [
    {
      name: t("Benchmark.Average_Page_Engagement_Rate"),
      nos_marque: taux_interactions_kf,
      verified: campareTwoValues(
        taux_interactions_kf,
        percentWithPrecision(taux_interaction_moy)
      ),
      moy_sec: percentWithPrecision(taux_interaction_moy),
    },
    {
      name: t("Benchmark.Average_Total_Number_Fans"),
      nos_marque: millifyAvecPrecision(total_fans_kf),
      verified: campareTwoValues(total_fans_kf, page_fans_moy),
      moy_sec: millifyAvecPrecision(page_fans_moy),
    },
    {
      name: t("Benchmark.Average_Number_Posts"),
      nos_marque: millifyAvecPrecision(total_posts_kf),
      verified: campareTwoValues(total_posts_kf, total_posts_moy),
      moy_sec: millifyAvecPrecision(total_posts_moy),
    },
    {
      name: t("Benchmark.Average_Number_Interactions_per_Post"),
      nos_marque: millifyAvecPrecision(nbr_moy_pub),
      verified: campareTwoValues(nbr_moy_pub, nbr_moy_pub_sec),
      moy_sec: millifyAvecPrecision(nbr_moy_pub_sec),
    },
    {
      name: t("Benchmark.Average_Number_Interactions_per_Page"),
      nos_marque: millifyAvecPrecision(total_interactions_kf),
      verified: campareTwoValues(total_interactions_kf, total_interactions_moy),
      moy_sec: millifyAvecPrecision(total_interactions_moy),
    },
    {
      name: t("Benchmark.Average_Number_Reactions_Page"),
      nos_marque: millifyAvecPrecision(reaction_kf),
      verified: campareTwoValues(reaction_kf, reaction_sec),
      moy_sec: millifyAvecPrecision(reaction_sec),
    },
    {
      name: t("Benchmark.Average_Number_Views_Page"),
      nos_marque: millifyAvecPrecision(views_kf),
      verified: campareTwoValues(views_kf, views_sec),
      moy_sec: millifyAvecPrecision(views_sec),
    },
    {
      name: t("Benchmark.Average_Number_Comments_Page"),
      nos_marque: millifyAvecPrecision(comments_kf),
      verified: campareTwoValues(comments_kf, comments_sec),
      moy_sec: millifyAvecPrecision(comments_sec),
    },
  ];

  const moy_sectorielles = props.data?.ids_sector?.moy_sectorielles;

  const moyData = [];
  const ids_sector_obj = {
    nbr_marque: moy_sectorielles["nbr_marques"],
    page_fans: millifyAvecPrecision(moy_sectorielles["total_fans"]),
    total_post: millifyAvecPrecision(moy_sectorielles["total_posts"]),
    total_interactions: millifyAvecPrecision(
      moy_sectorielles["total_interactions"]
    ),
    taux_interaction:
      millifyAvecPrecision(moy_sectorielles["taux_interactions"]) + "%",
    nbr_posts_jour: millifyAvecPrecision(
      moy_sectorielles["nbr_posts_par_jour"]
    ),
    posts_images: millifyAvecPrecision(moy_sectorielles["posts_images"]),
    posts_videos: millifyAvecPrecision(moy_sectorielles["posts_videos"]),
    posts_others: millifyAvecPrecision(moy_sectorielles["posts_others"]),
  };
  moyData.push(ids_sector_obj);

  const DataTableCrudDemo2 = () => {
    let emptyProduct = {
      id: null,
      name: "",
      page_fans: 0,
      posts_count: 0,
      posts_interactions: 0,
      posts_engagement: 0,
    };

    const [products, setProducts] = useState(null);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    prdcts.data = props.cmpData.data;

    const table_data_youtube = [];
    dataBench.forEach((benchmark) => {
      const nbr_posts_jour_result = totalJours
        ? (benchmark.posts_media / totalJours).toFixed(3)
        : 0;
      const table_data_obj = {
        name: benchmark.name,
        posts_count:
          benchmark.total_videos !== 0
            ? benchmark.total_videos
            : "non disponible",
        page_fans:
          benchmark.total_abonnees !== 0
            ? benchmark.total_abonnees
            : "non disponible",
        posts_interactions: benchmark.total_interactions,
        posts_engagement:
          benchmark.taux_interactions !== 0
            ? benchmark.taux_interactions.toFixed(3) + " %"
            : "non disponible",
        nbr_posts_jour: nbr_posts_jour_result,
        post_short: benchmark.posts_short,
        post_video: benchmark.posts_videos,
        post_live: benchmark.posts_live,
      };
      table_data_youtube.push(table_data_obj);
    });

    useEffect(() => {
      setProducts(prdcts.data);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const hideDialog = () => {
      setSubmitted(false);
      setProductDialog(false);
    };

    const hideDeleteProductDialog = () => {
      setDeleteProductDialog(false);
    };

    const hideDeleteProductsDialog = () => {
      setDeleteProductsDialog(false);
    };

    const saveProduct = () => {
      setSubmitted(true);

      if (product.name.trim()) {
        let _products = [...products];
        let _product = { ...product };
        if (product.id) {
          const index = findIndexById(product.id);

          _products[index] = _product;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          _product.id = createId();
          // _product.image = "product-placeholder.svg";
          _products.push(_product);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        setProducts(_products);
        setProductDialog(false);
        setProduct(emptyProduct);
      }
    };

    const deleteProduct = () => {
      let _products = products.filter((val) => val.id !== product.id);
      setProducts(_products);
      setDeleteProductDialog(false);
      setProduct(emptyProduct);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    };

    const findIndexById = (id) => {
      let index = -1;
      for (let i = 0; i < products.length; i++) {
        if (products[i].id === id) {
          index = i;
          break;
        }
      }

      return index;
    };

    const createId = () => {
      let id = "";
      let chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    };

    const deleteSelectedProducts = () => {
      let _products = products.filter((val) => !selectedProducts.includes(val));
      setProducts(_products);
      setDeleteProductsDialog(false);
      setSelectedProducts(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    };

    const onCategoryChange = (e) => {
      let _product = { ...product };
      _product["category"] = e.value;
      setProduct(_product);
    };

    const onInputChange = (e, name) => {
      const val = (e.target && e.target.value) || "";
      let _product = { ...product };
      _product[`${name}`] = val;

      setProduct(_product);
    };

    const onInputNumberChange = (e, name) => {
      const val = e.value || 0;
      let _product = { ...product };
      _product[`${name}`] = val;

      setProduct(_product);
    };

    const printChart = (event) => {
      event.preventDefault();

      let target = event.target;
      let parent =
        target.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement.parentElement;
      let name = parent.getAttribute("data-value");
      parent.classList.add("capture_style");

      html2canvas(parent, {
        onclone: (document) => {
          document.querySelector(
            ".p-paginator.p-component.p-paginator-bottom"
          ).style.visibility = "hidden";
        },
      }).then((canvas) => {
        const data = canvas.toDataURL("image/jpg");
        const link = document.createElement("a");

        if (typeof link.download === "string") {
          link.href = data;
          link.download = name + ".jpg";

          parent.classList.remove("capture_style");

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.open(data);
        }
      });
    };

    const header = (
      <div className="table-header">
        <div className="flex  items-center w-full">
          <div className="flex flex-col">
            <h1 className="mx-0 my-1 text-[24px]">{t("Benchmark.summary")}</h1>
            <p>{t("Benchmark.summary_desc")}</p>
          </div>
          <div className="ml-auto" data-html2canvas-ignore>
            <div className="flex items-center mb-2">
              <button
                onClick={printChart}
                className="ml-auto mr-1.5 w-5 h-5 print_capture"
              ></button>
            </div>
            <span className="p-input-icon-left items-right">
              <i className="pi pi-search" />
              <InputText
                type="search"
                onInput={(e) => setGlobalFilter(e.target.value)}
                placeholder={t("Options.search")}
              />
            </span>
          </div>
        </div>
      </div>
    );

    const productDialogFooter = (
      <React.Fragment>
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-text"
          onClick={hideDialog}
        />
        <Button
          label="Save"
          icon="pi pi-check"
          className="p-button-text"
          onClick={saveProduct}
        />
      </React.Fragment>
    );
    const deleteProductDialogFooter = (
      <React.Fragment>
        <Button
          label="No"
          icon="pi pi-times"
          className="p-button-text"
          onClick={hideDeleteProductDialog}
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          className="p-button-text"
          onClick={deleteProduct}
        />
      </React.Fragment>
    );
    const deleteProductsDialogFooter = (
      <React.Fragment>
        <Button
          label="No"
          icon="pi pi-times"
          className="p-button-text"
          onClick={hideDeleteProductsDialog}
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          className="p-button-text"
          onClick={deleteSelectedProducts}
        />
      </React.Fragment>
    );

    return (
      <div className="datatable-crud-demo">
        <Toast ref={toast} />

        <div data-value="Résumé" className="card">
          <DataTable
            ref={dt}
            value={table_data_youtube}
            selection={selectedProducts}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            dataKey="id"
            paginator
            rows={10}
            tableStyle={{ minWidth: "50rem" }}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Brand"
            globalFilter={globalFilter}
            header={header}
            responsiveLayout="scroll"
          >
            <Column
              field="name"
              header={t("Benchmark.marque")}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="page_fans"
              header="Total abonneés"
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
              body={(rowData) => rowData.page_fans.toLocaleString()}
            ></Column>

            <Column
              field="posts_count"
              header="Total vidéos"
              sortable
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>
            <Column
              field="posts_interactions"
              header="Total interactions"
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>
            <Column
              field="posts_engagement"
              header={t("Performance_report.interaction_rate")}
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>
            <Column
              field="nbr_posts_jour"
              header={t("Benchmark.number_of_videos_per_day")}
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>
            <Column
              field="post_short"
              header={t("Benchmark.posts_shorts")}
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>
            <Column
              field="post_video"
              header={t("Benchmark.posts_videos")}
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>

            <Column
              field="post_live"
              header={t("Benchmark.posts_live")}
              headerStyle={{ fontSize: "14px", lineHeight: "1.07" }}
              sortable
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#344563",
                fontFamily: "inter",
                lineHeight: "1.2",
              }}
            ></Column>
          </DataTable>
        </div>

        <Dialog
          visible={productDialog}
          style={{ width: "450px" }}
          header="Product Details"
          modal
          className="p-fluid"
          footer={productDialogFooter}
          onHide={hideDialog}
        >
          <div className="field">
            <label htmlFor="name">Name</label>
            <InputText
              id="name"
              value={product.name}
              onChange={(e) => onInputChange(e, "name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !product.name,
              })}
            />
            {submitted && !product.name && (
              <small className="p-error">Name is required.</small>
            )}
          </div>
          <div className="field">
            <label htmlFor="description">Description</label>
            <InputTextarea
              id="description"
              value={product.description}
              onChange={(e) => onInputChange(e, "description")}
              required
              rows={3}
              cols={20}
            />
          </div>

          <div className="field">
            <label className="mb-3">Category</label>
            <div className="formgrid grid">
              <div className="field-radiobutton col-6">
                <RadioButton
                  inputId="category1"
                  name="category"
                  value="Accessories"
                  onChange={onCategoryChange}
                  checked={product.category === "Accessories"}
                />
                <label htmlFor="category1">Accessories</label>
              </div>
              <div className="field-radiobutton col-6">
                <RadioButton
                  inputId="category2"
                  name="category"
                  value="Clothing"
                  onChange={onCategoryChange}
                  checked={product.category === "Clothing"}
                />
                <label htmlFor="category2">Clothing</label>
              </div>
              <div className="field-radiobutton col-6">
                <RadioButton
                  inputId="category3"
                  name="category"
                  value="Electronics"
                  onChange={onCategoryChange}
                  checked={product.category === "Electronics"}
                />
                <label htmlFor="category3">Electronics</label>
              </div>
              <div className="field-radiobutton col-6">
                <RadioButton
                  inputId="category4"
                  name="category"
                  value="Fitness"
                  onChange={onCategoryChange}
                  checked={product.category === "Fitness"}
                />
                <label htmlFor="category4">Fitness</label>
              </div>
            </div>
          </div>

          <div className="formgrid grid">
            <div className="field col">
              <label htmlFor="posts_count">posts_count</label>
              <InputNumber
                id="posts_count"
                toFixed
                value={product.posts_count}
                // value={100}
                onValueChange={(e) => onInputNumberChange(e, "posts_count")}
                integeronly
              />
              <InputNumber
                id="posts_count-rate"
                value={100}
                onValueChange={(e) => onInputNumberChange(e, "posts_count")}
                integeronly
              />
            </div>
            <div className="field col">
              <label htmlFor="posts_engagement">posts_engagement</label>
              <InputNumber
                id="posts_engagement"
                value={product.posts_engagement.toFixed(3)}
                onValueChange={(e) =>
                  onInputNumberChange(e.toFixed(3), "posts_engagement")
                }
                integeronly
              />
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={deleteProductDialog}
          style={{ width: "450px" }}
          header="Confirm"
          modal
          footer={deleteProductDialogFooter}
          onHide={hideDeleteProductDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{ fontSize: "2rem" }}
            />
            {product && (
              <span>
                Are you sure you want to delete <b>{product.name}</b>?
              </span>
            )}
          </div>
        </Dialog>

        <Dialog
          visible={deleteProductsDialog}
          style={{ width: "450px" }}
          header="Confirm"
          modal
          footer={deleteProductsDialogFooter}
          onHide={hideDeleteProductsDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{ fontSize: "2rem" }}
            />
            {product && (
              <span>
                Are you sure you want to delete the selected products?
              </span>
            )}
          </div>
        </Dialog>
      </div>
    );
  };
  /*---- Option 22 */
  let options22 = {
    chart: {
      type: "column",
    },
    title: {
      text: t("Performance_report.audience_growth"),
      align: "left",
      margin: 50,
    },
    subtitle: {
      text: t("Benchmark.audience_growth_desc"),
      align: "left",
      margin: 10,
    },
    tooltip: {
      enabled: false,
    },
    xAxis: {
      labels: {
        enabled: false,
      },
      categories: [],
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    legend: {
      enabled: true,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          //format: '{point.y:.1f}'
        },
      },
    },
    series: [{}],
  };
  /*--- End option 22 */
  const dataBenchOp = props?.data?.youtube?.dataBench?.total;
  const arr_data_option22 = [];
  options22.xAxis.categories.push("");

  for (const tt in dataBenchOp) {
    // Vérifier la valeur de tt.page_id et définir la couleur en conséquence
    let color;
    if (dataBenchOp[tt].page_id === 323) {
      //-- Orange
      color = "#f16e00";
    } else if (dataBenchOp[tt].page_id === 325) {
      //-- Ooredoo
      color = "#ed1c24";
    } else if (dataBenchOp[tt].page_id === 330) {
      //-- Tunisie
      color = "#001e8c";
    }

    const arr = {
      name: dataBenchOp[tt].name,
      data: [dataBenchOp[tt].total_abonnees],
      color: color,
    };
    arr_data_option22.push(arr);
  }
  arr_data_option22.map((entry, index) => {
    options22.series.push(entry);
  });

  function remove_empty_value(arr) {
    var index;
    arr.some(function (obj, i) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
        ? ((index = i), true)
        : false;
    });
    arr.shift(index);
    return index;
  }
  remove_empty_value(options22.series);
  /*--- End option 22 */

  const printChart1 = (event) => {
    event.preventDefault();

    let target = event.target;
    let parent = target.parentElement.parentElement;
    let name = parent.getAttribute("data-value");
    parent.classList.add("capture_style");

    html2canvas(parent, {
      onclone: (document) => {},
    }).then((canvas) => {
      const data = canvas.toDataURL("image/jpg");
      const link = document.createElement("a");

      if (typeof link.download === "string") {
        link.href = data;
        link.download = name + ".jpg";

        parent.classList.remove("capture_style");

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(data);
      }
    });
  };

  return (
    <div>
      <div className="mb-5">
        <DataTableCrudDemo2 className=""></DataTableCrudDemo2>
        <div className="p-5 bg-white">
          <h2 className="mb-7 text-[24px] font-semibold">
            {t("Benchmark.Sector_Averages")}
          </h2>

          <DataTable value={moy_data_youtube}>
            <Column
              field="nbr_marque"
              header={t("Benchmark.number_brands")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="page_fans"
              header={t("Performance_report.total_Subscribers")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="total_post"
              header={t("Performance_report.total_videos")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="total_interactions"
              header="Total interactions"
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="taux_interaction"
              header={t("Performance_report.interaction_rate")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="nbr_posts_jour"
              header={t("Benchmark.number_of_videos_per_day")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="posts_shorts"
              header={t("Benchmark.posts_shorts")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="posts_videos"
              header={t("Benchmark.posts_videos")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>

            <Column
              field="posts_live"
              header={t("Benchmark.posts_live")}
              style={{
                width: "12.5%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
          </DataTable>
        </div>

        <div className="p-5 bg-white">
          <h2 className="mb-7 text-[24px] font-semibold">
            {t("Benchmark.Key_Metrics")}
          </h2>

          <DataTable value={chiffre_key}>
            <Column
              field="name"
              header=""
              style={{
                //width: "33.33333333%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="nos_marque"
              header={t("Benchmark.our_brand")}
              bodyStyle={{ textAlign: "center" }}
              className="center_header"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="verified"
              header=""
              bodyStyle={{ textAlign: "center" }}
              className="center_header"
              style={{
                //width: "33.33333333%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
            <Column
              field="moy_sec"
              header={t("Benchmark.Sector_Averages")}
              bodyStyle={{ textAlign: "center" }}
              className="center_header"
              style={{
                //width: "20%",
                fontSize: "14px",
                fontWeight: "600",
                color: "#152935",
                fontFamily: "inter",
              }}
            ></Column>
          </DataTable>
        </div>
      </div>

      <div data-value="Variations des Fans" className="highchart_block1 mb-5">
        <div className="flex items-center">
          <button
            data-html2canvas-ignore
            onClick={printChart1}
            className="ml-auto mr-1.5 w-5 h-5 print_capture"
          ></button>
        </div>
        <HighchartsReact highcharts={Highcharts} options={options22} />
      </div>
    </div>
  );
};
export default TableCombinedYoutube;
